// extracted by mini-css-extract-plugin
export var checked = "forms-module--checked--7dabc";
export var title = "forms-module--title--b78d2";
export var unchecked = "forms-module--unchecked--24498";
export var wrapper = "forms-module--wrapper--4463c";